import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configuration from '~/configuration/configuration';
import store from '~/store/store';

import App from './app';
import RootErrorBoundary from './root-error-boundary';
import StyleSheetManagerProvider from './style-sheet-manager';
import { setupErrorReporter } from '@comeon/error-reporter';

const urlLang = window.location.pathname.split('/')[0];
const currentUrlLang = store ? store.getState().brand.currentUrlLang : '';
const baseUrlLang = `/${currentUrlLang || urlLang}`;
const DEV = process.env.NODE_ENV !== 'production';

/* need this hacky redirection for local, if location doesnt include
lang code, Router will not render anything */
if (DEV && !window.location.pathname.startsWith(baseUrlLang)) {
	window.location.pathname = `${baseUrlLang}${window.location.pathname}`;
}

if (configuration.sentryEnabled) {
	setupErrorReporter({
		url: configuration.sentryUrl,
		environment: configuration.sentryEnvironment,
		releaseVersion: configuration.releaseVersion,
		tracingEnabled: configuration.sentryTracingEnabled,
		replayEnabled: configuration.sentrySessionReplayEnabled,
		replaysSessionSampleRate: configuration.sentryReplaysSessionSampleRate,
		replaysOnErrorSampleRate: configuration.sentryReplaysOnErrorSampleRate,
		tracesSampleRate: configuration.sentryTracesSampleRate,
		ignoreErrorStrings: configuration.sentryIgnoreErrorStrings,
		ignoreErrorRegexStrings: configuration.sentryIgnoreErrorRegexStrings,
		debugMode: configuration.sentryDebugModeEnabled,
		filterThirdPartyErrors: configuration.sentryFilterThirdPartyErrors
	});
}

const Root = () => (
	<Provider store={store}>
		<RootErrorBoundary
			reload={!DEV && !configuration.debugMode}
			delay={500}
			errorTimeThreshold={4000}
			maxReloads={2}
		>
			<BrowserRouter basename={baseUrlLang}>
				{/* TODO: this needs to be cleaned up, its only to prevent warnings on the browser, but we may need to migrate to using transient props and then remove this wrapper
					this  */}
				<StyleSheetManagerProvider>
					<App />
				</StyleSheetManagerProvider>
			</BrowserRouter>
		</RootErrorBoundary>
	</Provider>
);

// Exposing redux store for Cypress testing
if (window.Cypress && configuration.isIntegrationTesting) {
	window.store = store;
}

export default Root;
